import { storageSaveData } from '@browsing/utils';
import {
    setCrossCampaignFilters,
    defaultFilterState,
    SessionStorageKeys,
    setCrossCampaignFiltersCategoryId,
} from '@browsing/filters';

const storageType = 'sessionStorage';

export function redirectToCrossCampaignCatalog(categoryId: number) {
    setCrossCampaignFiltersCategoryId(categoryId);
    window.location.href = `/articles/categories/${[categoryId]}`;
}

export function redirectToCrossCampaignCatalogMultiCategorySelect(categoryIds: number[]) {
    setCrossCampaignFilters({ ...defaultFilterState, categories: categoryIds });
    window.location.href = `/articles/categories/${categoryIds}`;
}

enum CrossCampaignEntryKeys {
    VisitedCatalog = 'visited-catalog',
}

function setCrossCampaignEntry(key: CrossCampaignEntryKeys, payload: boolean) {
    storageSaveData({
        key: SessionStorageKeys.CrossCampaignEntry,
        subKey: key,
        payload,
        overwrite: false,
        storageType,
    });
}

function readSessionStoragekey<T = Record<string, any>>(key: SessionStorageKeys): T | null {
    try {
        return JSON.parse(sessionStorage[key]) as T;
    } catch (e) {
        return null;
    }
}

export function setVisitedCrossCampaignCatalog(payload: boolean) {
    setCrossCampaignEntry(CrossCampaignEntryKeys.VisitedCatalog, payload);
}

export function getSavedCategoryIds(): false | number[] {
    try {
        const crossCampaignEntry = readSessionStoragekey(
            SessionStorageKeys.CrossCampaignEntry,
        ) as Record<CrossCampaignEntryKeys, boolean>;

        if (!crossCampaignEntry) {
            return false;
        }

        const visitedCatalog = crossCampaignEntry[CrossCampaignEntryKeys.VisitedCatalog];

        if (!visitedCatalog) {
            return false;
        }

        const filters = readSessionStoragekey(SessionStorageKeys.Filters);

        if (!filters) {
            return false;
        }

        return (
            (filters as Record<string, { categories?: number[] }>)['cross-campaign']?.categories ||
            false
        );
    } catch (error) {
        return false;
    } finally {
        setVisitedCrossCampaignCatalog(false);
    }
}
